const bazarBt = {
	common: {
		brandLabel: 'བརནཌ་',
		storeLabel: 'ཚོང་ཁང་',
		unitCount: 'ཀླད་'
	},
	search: {
		placeholders: [
			'ཐེབས་མིང་བཙུགས།...',
			'བརནཌ་མིང་བཙུགས།...',
			'ཚོང་ཁང་མིང་བཙུགས།...',
			'དཀར་ཆག་མིང་བཙུགས།...'
		]
	},
	sidebar: {
		categoriesTitle: 'དཀར་ཆག',
		storesTitle: 'ཚོང་ཁང་ཐོ་ཡིག'
	},
	store: {
		serviceAreaLabel: 'སྦྱོར་ཞུའི་ཁུལ་',
		nationwide: 'རྒྱལ་ཡོངས་',
		productCount: 'ཐེབས་',
		productsOfSuffix: 'གི་ཐེབས་',
		description: 'འོག་ལུ་ ཚོང་ཁང་འདི་ནས་ཐོབ་ཚུགས་པའི་ཐེབས་ཚང་མ་མངོན་ཡོད། དཀར་ཆག་གིས་འཚོལ་ཞིབ་བྱས་ཆོག'
	},
	buttons: {
		details: 'རྒྱས་པ་',
		addToCart: 'ཀརཊ་ནང་བཙུགས།',
		clearFilters: 'ཚགས་མེད་བཟོ།',
		close: 'ཁ་བསྡམས།'
	},
	empty: {
		title: 'ཐེབས་མེད་པ',
		subtitle: 'ཚགས་ཡང་ན་འཚོལ་ཞིབ་སྒྲིག་བཟོ་གནང་།'
	}
};

export default bazarBt;


